import Icon from "../Icon";
import "./index.scss";

const AlertBanner = ({
  data,
  showGreeting,
  isClosing,
  onClose,
  type = "greeting",
  message,
  children,
  className = "",
  isBannerClosable = true,
}) => {
  if (!showGreeting) return null;

  return (
    <div
      className={`alert-banner alert-banner--${type}${
        isClosing ? " alert-banner--closing" : ""
      } ${className}`}
    >
      {isBannerClosable && (
        <button
          className="alert-banner__close"
          onClick={onClose}
          aria-label="Close notification"
        >
          <Icon
            className="alert-banner__close-icon"
            iconName="closeCircle"
            width={24}
            height={24}
          />
        </button>
      )}

      {children ? (
        <div className="alert-banner__content">{children}</div>
      ) : (
        <h2 className="alert-banner__message">
          {message}
          {data ? `, ${data}` : ""}
        </h2>
      )}
    </div>
  );
};

export default AlertBanner;
